var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3640_9823)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3640_9823",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.263184,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3640_9823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7148 12C10.3398 12 9.16276 11.5104 8.18359 10.5312C7.20443 9.55208 6.71484 8.375 6.71484 7C6.71484 5.625 7.20443 4.44792 8.18359 3.46875C9.16276 2.48958 10.3398 2 11.7148 2C13.0898 2 14.2669 2.48958 15.2461 3.46875C16.2253 4.44792 16.7148 5.625 16.7148 7C16.7148 8.375 16.2253 9.55208 15.2461 10.5312C14.2669 11.5104 13.0898 12 11.7148 12ZM1.71484 22V18.5C1.71484 17.7917 1.89734 17.1404 2.26234 16.5463C2.62651 15.9529 3.11068 15.5 3.71484 15.1875C5.00651 14.5417 6.31901 14.0571 7.65234 13.7338C8.98568 13.4113 10.3398 13.25 11.7148 13.25C13.0898 13.25 14.444 13.4113 15.7773 13.7338C17.1107 14.0571 18.4232 14.5417 19.7148 15.1875C20.319 15.5 20.8032 15.9529 21.1673 16.5463C21.5323 17.1404 21.7148 17.7917 21.7148 18.5V22H1.71484Z",
    fill: "#6E6E6E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3640_9823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.263184)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.f304bbb39e3bb6f332abe76cabd115ad.svg";
export { ForwardRef as ReactComponent };